export const ORDER_STAGES = [
  { key: "ORDER_PLACED", label: "Order Placed" },
  { key: "VENDOR_ACCEPTED", label: "Accepted by Vendor" },
  { key: "LOOKING_FOR_AGENT", label: "Looking for Delivery Agent" },
  { key: "AGENT_ASSIGNED", label: "Agent Assigned" },
  { key: "MANUFACTURING", label: "Product Manufacturing" },
  { key: "INTERNATIONAL_TRANSIT", label: "International Transit" },
  { key: "CUSTOMS_CLEARANCE", label: "Customs Clearance" },
  { key: "LOCAL_TRANSIT", label: "Local Transit" },
  { key: "DELIVERED", label: "Delivered" },
];
